<template>
  <div class="relative">
    <select v-model="selected" class="form-input" id="category">
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>
    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
      <base-svg-icon class="w-6 fill-current" :path="mdiChevronDown" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { mdiChevronDown } from '@mdi/js'
import { SelectOptionItem } from '@/types/forms/select'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    selectedVal: {
      type: [String, Number],
      'default': () => (undefined),
    },
    options: {
      type: Array as PropType<SelectOptionItem[]>,
      'default': () => ([]),
    },
  },
  emits: ['update:selectedVal'], //https://vuejs.org/guide/components/events.html#v-model-arguments
  setup(props, context) {
    const selected = computed({
      get() {
        return props.selectedVal
      },
      set(value) {
        context.emit('update:selectedVal', value)
      }
    })

    return {
      mdiChevronDown,
      selected
    }
  },
})
</script>
